export default {
    header: {
        self: {},
        items: [],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "dashboard",
                bullet: "dot",
            },
            {
                title: "Closers",
                root: true,
                icon: "fas fa-headset",
                page: "closer",
                bullet: "dot",
            },
            {
                title: "Motoristas",
                root: true,
                icon: "fas fa-truck",
                page: "motorista",
                bullet: "dot",
            },
            {
                title: "Clientes",
                root: true,
                icon: "fas fa-building",
                page: "cliente",
                bullet: "dot",
            },
            {
                title: "Importar HTML",
                root: true,
                icon: "fas fa-file-code",
                page: "scrapper",
                bullet: "dot",
            },
            {
                title: "Relatórios",
                root: true,
                bullet: "dot",
                icon: "fas fa-chart-pie",
                submenu: [
                    {
                        title: "Novos Clientes",
                        bullet: "dot",
                        page: "relatorio/novos-clientes",
                    },
                ],
            },
            {
                title: "Acessos",
                root: true,
                bullet: "dot",
                icon: "fas fa-user-shield",
                submenu: [
                    {
                        title: "Usuários",
                        bullet: "dot",
                        page: "admin",
                    },
                    {
                        title: "Grupos de usuários",
                        bullet: "dot",
                        page: "grupo",
                    },
                ],
            },
        ],
    },
};
